import { FC } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { routes } from "~/constants";
import { usePartner } from "../hooks";

export const PartnerRedirector: FC = () => {
  const location = useLocation();
  const { isPartner } = usePartner();

  if (!isPartner) {
    return <Navigate to={routes.onboardingRoot} state={location.state} />;
  }

  return (
    <>
      <Outlet />
    </>
  );
};
